var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ApolloLink } from '@apollo/client';
import { Observable } from '@apollo/client';
import { LocalStorage } from 'libs/storage/LocalStorage';
/**
 * Adds the session token to requests.
 * @function request
 * @since 1.0.0
 */
const request = (operation) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = {
        'X-API-Key': 'EFE48A3CDDA0BED4C37336CF38B1F5F95C7B1BA19408CFB9778595DAB34B4C29',
        'X-API-Ver': '1.0'
    };
    const token = LocalStorage.get('session.token');
    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }
    operation.setContext({ headers });
});
/**
 * Manages requests.
 * @const requestLink
 * @since 1.0.0
 */
export const requestLink = new ApolloLink((operation, forward) => new Observable((observer) => {
    let handle;
    Promise.resolve(operation)
        .then(request)
        .then(() => {
        handle = forward(operation).subscribe({
            next: observer.next.bind(observer),
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer)
        });
    })
        .catch(observer.error.bind(observer));
    return () => handle && handle.unsubscribe();
}));
